import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import plimage from '../../../../../../../assets/img/sonic-pricing-table.png';
import Qualifiers from './Qualifiers';
import LeadOptions from './LeadOptions';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const styles = theme => ({
  root: {
      marginTop: theme.spacing.unit * 2,
      padding: theme.spacing.unit * 2
  },
  prices:{
    padding: theme.spacing.unit * 2
  },
  title: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  divider:{
    marginTop: theme.spacing.unit,
  //  marginLeft: theme.spacing.unit * 2
  },
  plimage: {
    width: '100%',
    padding: theme.spacing.unit * 2,
  },
  checked: {},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
})

function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

@inject("commonStore")
@observer
class TieredPricing extends React.Component {
  state = {
    none: true,
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount(){
      console.log('componentDidMount')
      const { conditions } = this.props
      const update = {}
      console.log(this.props)
      if(conditions){
        for (const condition of conditions){
          update[condition] = true
        }
      }
      this.setState(update)
  }
  makeDialog = () => {
    const { open } = this.state
    const { classes } = this.props
    return <Dialog
  //  fullScreen
    maxWidth={'lg'}
    open={open}
    onClose={this.handleClose}
    TransitionComponent={Transition}
  >
  <DialogTitle id="alert-dialog-slide-title">
       {'Price Levels'}
  </DialogTitle>

    <DialogContent>
    <Typography>Please reference the table below to understand how Sonic Leads are scored according to their reported income level x household size (FPL%). Lead routing is based on your active campaign specifications, and all fulfillment is final. A comprehensive lead list can be found in the Leads tab of your dashboard.</Typography>
    <Grid 
    container
    spacing={24}>

      <Grid item xs={12}>
        <Paper className={classes.paper}>    
        <Typography variant="headline" color="textSecondary">Leads Categorized by Federal Poverty Level </Typography>
        <img src={plimage} className={classes.plimage}/>
        </Paper>
      </Grid>
    </Grid>
    </DialogContent>
    <DialogActions>
    <Button onClick={this.handleClose} color="primary">
      Close
    </Button>
  </DialogActions>

  </Dialog>

  }
  updateCampaign = () => {
    const { fixed } = this.state
    const { handleUpdate } = this.props
    console.log('updateCampaign')
      console.log(this.state)
      const stateKeys = Object.keys(this.state)
      const conditions = []
      for (const key of stateKeys){
       //    if(key !== 'fixed'){
              if(this.state[key]){
                conditions.push(key)
              }
       //    }
      }
      console.log(conditions)
      handleUpdate(conditions)
    
  }
  makeLabel = (value) => {
    const splitArray = value.split('_')
    if(splitArray.length > 1){
      return `${jsUcfirst(splitArray[0])} ${jsUcfirst(splitArray[1])}`
    }
    return jsUcfirst(value)
}
  makeWarnings = () => {
    const { filters, leadType, qualifiers, contactTypes } = this.props
    const warnings = []
    for(let qualifier of qualifiers ){
      for(let contact of contactTypes ){
        const filterArray = filters[leadType]['qualifiers'][qualifier][contact]
        const index = filterArray.findIndex(x => x.field === 'condition:povertyLevel');
          if(index > -1){
            if (filterArray[index].include.length > 1){
              continue
            }
          }else{
            warnings.push(
              <div key={`${qualifier}_${contact}`} style={{color:'#DFC10F'}}>
              <Typography color={'inherit'} component="p">
              <Icon>warning</Icon>  {`Please select price levels for ${this.makeLabel(qualifier)} ${this.makeLabel(contact)}`}
              </Typography>
              </div>
            )
          }
      }
    }
    return warnings
  }
  render() {
    const { classes, commonStore, leadType, ...otherProps } = this.props;
    console.log(this.props)
    /*
          <Button className={classes.title} color="primary" onClick={this.handleClickOpen}>
        Click To View Poverty Level Descriptions
      </Button>
    */
    return (

     <div> 
     <LeadOptions leadType={leadType} {...otherProps}/>
     <Divider className={classes.divider} /> 
     

      {this.makeWarnings()}
     <Typography className={classes.title} variant="h5">Step 3: Set Filters for Each Qualifier’s Contact Type</Typography>

     <Qualifiers leadType={leadType} openPLModal={this.handleClickOpen} {...otherProps} /> 
     
     <Typography style={{marginBottom: 20, marginTop: 20}}>For our terms of service and for more information about our lead specifications & return policy, please reference the Lead Info tab in your dashboard.</Typography>
      {this.makeDialog()}

     </div> 
    );
  }
}

TieredPricing.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TieredPricing);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/Filters/Tiered/index.js